


import React, { useState, useMemo } from 'react';
import { useStore } from '../../context/StoreContext';
// FIX: Use Order and OrderStatus instead of Sale and SaleStatus as StoreContext only manages orders
import { Order, OrderStatus } from '../../types';
import { Clock, CheckCircle, Search, History, X, ChevronRight, Hash, TrendingUp, Users, DollarSign } from 'lucide-react';

// FIX: Updated component props to use Order and OrderStatus types
const SaleCard: React.FC<{ sale: Order, onAction: (id: string, next: OrderStatus) => void }> = ({ sale, onAction }) => {
    // FIX: Defined a valid transition map for OrderStatus instead of SaleStatus
    const nextStatusMap: Partial<Record<OrderStatus, OrderStatus>> = {
        'PENDING': 'CONFIRMED',
        'CONFIRMED': 'PREPARING',
        'PREPARING': 'READY',
        'READY': 'COMPLETED'
    };
    const nextStatus = nextStatusMap[sale.status];

    return (
        <div className="bg-white/5 border border-white/10 rounded-3xl p-6 hover:bg-white/10 transition-all border-l-4 border-l-purple-500">
            <div className="flex justify-between items-start mb-4">
                <div>
                    <span className="text-[10px] font-black text-gray-500 uppercase">#{sale.shortId}</span>
                    <h4 className="text-xl font-black text-white tracking-tight">{sale.customerName}</h4>
                </div>
                <div className="text-right">
                    <div className="text-lg font-black text-white">R$ {sale.total.toFixed(2)}</div>
                </div>
            </div>
            
            <div className="space-y-2 mb-6">
                {sale.items.map((item, i) => (
                    // FIX: Order items are CartItem which have a productName property
                    <div key={i} className="text-xs text-gray-400 font-medium">• {item.quantity}x {item.productName}</div>
                ))}
            </div>

            {/* FIX: Added conditional check to ensure we only show the action button when a next status exists */}
            {nextStatus && (
                <button 
                    onClick={() => onAction(sale.id, nextStatus)}
                    className="w-full bg-white text-black font-black py-3 rounded-xl text-xs hover:bg-gray-200 transition-all flex items-center justify-center gap-2"
                >
                    AVANÇAR ESTÁGIO <ChevronRight className="w-4 h-4" />
                </button>
            )}
        </div>
    );
};

const SalesPipeline: React.FC = () => {
    // FIX: Access orders and updateSaleStatus from StoreContext (sales was undefined)
    const { orders, updateSaleStatus } = useStore();
    
    // FIX: Redefined columns to use supported OrderStatus values
    const columns: { status: OrderStatus, label: string }[] = [
        { status: 'PENDING', label: 'Novos Pedidos' },
        { status: 'CONFIRMED', label: 'Aceitos' },
        { status: 'PREPARING', label: 'Preparação' },
        { status: 'READY', label: 'Finalização' }
    ];

    return (
        <div className="h-full flex flex-col -m-6 p-6 bg-secondary-950 overflow-hidden">
            <header className="mb-10">
                <h1 className="text-6xl font-black text-white tracking-tighter">PIPELINE <span className="text-purple-500">CRM</span></h1>
                <p className="text-gray-500 font-bold uppercase text-xs tracking-widest mt-2 flex items-center gap-2">
                    {/* FIX: Filter using orders array and status logic */}
                    <TrendingUp className="w-4 h-4 text-green-500" /> {orders.filter(s => s.status !== 'COMPLETED' && s.status !== 'CANCELLED').length} Negócios Ativos
                </p>
            </header>

            <div className="flex-1 flex gap-6 overflow-x-auto no-scrollbar pb-10">
                {columns.map(col => (
                    <div key={col.status} className="w-80 shrink-0 flex flex-col">
                        <div className="flex items-center justify-between mb-4 px-2">
                            <h3 className="font-black text-white text-sm uppercase tracking-widest flex items-center gap-2">
                                <div className="w-2 h-2 rounded-full bg-purple-500"></div>
                                {col.label}
                            </h3>
                            <span className="bg-white/5 text-gray-500 text-[10px] font-black px-2 py-0.5 rounded-full">
                                {orders.filter(s => s.status === col.status).length}
                            </span>
                        </div>
                        <div className="flex-1 space-y-4 overflow-y-auto no-scrollbar">
                            {/* FIX: Use orders.filter and map to render SaleCard correctly */}
                            {orders.filter(s => s.status === col.status).map(order => (
                                <SaleCard key={order.id} sale={order} onAction={updateSaleStatus} />
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SalesPipeline;
